import styled, { css } from 'styled-components';

export const Page = styled.div`
  ${({ theme }) => css`
    min-height: 100vh;
    background: ${theme.colors.surfaceContainerLowest};
    color: ${theme.colors.onSurface};
    font-family: ${theme.font.bodyLarge.fontFamily}, -apple-system, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.spacing.level8} ${theme.spacing.level6} 80px;

    @media (max-width: 768px) {
      padding: ${theme.spacing.level6} ${theme.spacing.level4} ${theme.spacing.level8};
    }
  `}
`;

export const Container = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.level6};
`;

export const Header = styled.div`
  text-align: center;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.font.headlineMedium.fontSize};
    font-weight: 700;
    color: ${theme.colors.onSurface};
    margin: 0 0 ${theme.spacing.level4};
    line-height: 1.2;
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.bodyLarge.fontSize};
    color: ${theme.colors.onSurfaceVariant};
    line-height: 1.6;
    margin: 0;

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }

      &:focus-visible {
        text-decoration: underline;
      }
    }
  `}
`;

export const PdfFrame = styled.iframe`
  ${({ theme }) => css`
    width: 100%;
    height: 60vh;
    min-height: 400px;
    border: 1px solid ${theme.colors.outlineVariant};
    border-radius: ${theme.borderRadius.medium};
    background: ${theme.colors.surfaceContainerLow};

    @media (max-width: 768px) {
      height: 50vh;
      min-height: 240px;
    }
  `}
`;

export const PdfFallback = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing.level3};
    border: 1px solid ${theme.colors.outlineVariant};
    border-radius: ${theme.borderRadius.medium};
    background: ${theme.colors.surfaceContainerLow};
    color: ${theme.colors.onSurfaceVariant};
    font-size: ${theme.font.bodyMedium.fontSize};

    a {
      color: ${theme.colors.primary};
      text-decoration: none;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  `}
`;

export const ButtonRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    gap: ${theme.spacing.level5};

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: stretch;
    }
  `}
`;

export const AcceptButton = styled.button<{ $loading?: boolean }>`
  ${({ theme, $loading }) => css`
    padding: 14px 40px;
    background: ${theme.colors.primary};
    color: ${theme.colors.onPrimary};
    border: none;
    border-radius: ${theme.borderRadius.small};
    font-size: ${theme.font.titleMedium.fontSize};
    font-weight: ${theme.font.titleMedium.fontWeight};
    font-family: ${theme.font.titleMedium.fontFamily}, sans-serif;
    cursor: pointer;
    opacity: ${$loading ? 0.7 : 1};
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: ${theme.colors.primaryContainer};
    }

    &:disabled {
      cursor: not-allowed;
    }

    @media (max-width: 480px) {
      width: 100%;
      padding: 14px;
    }
  `}
`;

export const DeclineButton = styled.button`
  ${({ theme }) => css`
    padding: 14px 40px;
    background: transparent;
    color: ${theme.colors.onSurfaceVariant};
    border: 1px solid ${theme.colors.outlineVariant};
    border-radius: ${theme.borderRadius.small};
    font-size: ${theme.font.titleMedium.fontSize};
    font-weight: ${theme.font.titleMedium.fontWeight};
    font-family: ${theme.font.titleMedium.fontFamily}, sans-serif;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: ${theme.colors.outline};
      color: ${theme.colors.onSurface};
    }

    @media (max-width: 480px) {
      width: 100%;
      padding: 14px;
    }
  `}
`;

// API errors use the shared ErrorBox from auth.styled
